import cusSearch from './components/cus-search/cus-search'
import cusSearchItem from './components/cus-search-item/cus-search-item'
import cusButton from './components/cus-button/cus-button'
import cusCard from './components/cus-card/cus-card'
import cusModal from './components/cus-modal/cus-modal'
import cusPage from './components/cus-page/cus-page'
import cusProgress from './components/cus-progress/cus-progress'
import cusUpload from './components/cus-upload/cus-upload'
import cusUploadIMG from './components/cus-uploadIMG/cus-uploadIMG'
import cusAutoComplete from './components/cus-autoComplete/cus-autoComplete'
import cusSticky from './components/cus-sticky/cus-sticky'

import deepClone from "./libs/function/deepClone";
import notice from "./libs/function/notice";
import {showLoading, hideLoading} from "./libs/function/loading";
import dialog from "./libs/function/dialog";
import debounce from "./libs/function/debounce";
import websocket from './libs/function/websocket'
import {fullScreen, exitFullScreen} from './libs/function/fullScreen'
import downloadIMG from './libs/function/downloadIMG'

let components = {
  cusPage,
  cusCard,
  cusButton,
  cusSticky,
  cusModal,
  cusSearch,
  cusSearchItem,
  cusProgress,
  cusUpload,
  cusUploadIMG,
  cusAutoComplete
}

let $cu = {
  deepClone,
  notice,
  showLoading,
  hideLoading,
  dialog,
  debounce,
  websocket,
  fullScreen,
  exitFullScreen,
  downloadIMG
}


const install = Vue => {

  Object.keys(components).forEach(val => {
    Vue.component(val, components[val]);
  })

  Vue.prototype.$cu = $cu;
  Vue.prototype.$cu.eventBus = new Vue();
}

export default {
  install
}



// WEBPACK FOOTER //
// ./src/cuview-ui/index.js